export const CREATE_VISIT_FORM_DETAILS = {
  PATIENT_NAME: "patientName",
  PATIENT_BSA_ID: "patientBSAId",
  CAMP_NAME: "campName",
  JUN: "jun",
  CHIEF_COMPLAINT: "chiefComplaint",
  INCIDENT_DATE: "incidentDate",
  INCIDENT_TIME: "incidentTime",
  INCIDENT_LOCATION: "incidentLocation",
  WITNESS_NAME: "witnessName",
  WITNESS_CONTACT_NAME: "witnessContactName",
  WITNESS_EMAIL: "witnessEmail",
  TYPE_OF_CARE: "typeOFCare",
  CAUSE_OF_INJURY_NAME: "causeOfInjury",
  FACILITY: "facility",
  TYPE_OF_CARE_NAME: "typeOfCareName",
};

export const CREATE_EMS_VISIT_FORM_DETAILS = {
  PATIENT_NAME: "patientName",
  PATIENT_BSA_ID: "patientBSAId",
  CAMP_NAME: "campName",
  JUN: "jun",
  CHIEF_COMPLAINT: "chiefComplaint",
  INJURY_TYPE: "injuryType",
  INJURY_LOCATION: "injuryLocation",
  CAUSE_OF_INJURY_NAME: "causeOfInjury",
  WITNESS_NAME: "witnessName",
  INCIDENT_LOCATION: "incidentLocation",
  INCIDENT_DATE: "incidentDate",
  INCIDENT_TIME: "incidentTime",
  TYPE_OF_CARE: "typeOFCare",
  FACILITY: "facility",
  TYPE_OF_CARE_NAME: "typeOfCareName",
};

export const TYPE_OF_SEVERITY = [
  { label: "Low", value: "low" },
  { label: "Moderate", value: "moderate" },
  { label: "High", value: "high" },
];
